module["exports"] = [
    "Assexual",
    "Feminino para homem trans homem",
    "Feminino para homem transgênero masculino",
    "Feminino para homem transexual",
    "Género neutro",
    "Hermafrodita",
    "Homem de intersexo",
    "Pessoa intersex",
    "Mulher intersexual",
    "Homem para mulher trans feminino",
    "Homem para mulher transexual feminina",
    "Homem para mulher transexual feminina",
    "Homem",
    "Pessoa de dois espíritos",
    "Mulher",
    "Agender",
    "Andrógino",
    "Andróginos",
    "Andrógino",
    "Cis",
    "Cis Feminino",
    "Cis Male",
    "Cis Man",
    "Cis Woman",
    "Cisgender",
    "Cisgender Female",
    "Cisgender Male",
    "Cisgender Man",
    "Cisgender Woman",
    "Female to Male",
    "Gender Fluid",
    "Género não conforme",
    "Gender Questioning",
    "Variante de Gênero",
    "Intersexo",
    "Macho para mulher",
    "Não-binário",
    "Outros",
    "Transexual",
    "Transexual Feminina",
    "Transexual Masculino",
    "Transexual Man",
    "Transexual Person",
    "Mulher Transexual",
    "Transgênero Feminino",
];
